var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPbDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pb-delete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 996",
    transform: "translate(1592 100)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1592 -100)",
    clipPath: "url(#pb-delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11806",
    d: "M1611.516 126.299a3.617 3.617 0 003.632-3.5l.415-12.817h1.946a.519.519 0 000-1.038h-5.448v-1.169a2.082 2.082 0 00-2.076-2.076h-3.944a2.082 2.082 0 00-2.076 2.076v1.168h-5.474a.519.519 0 100 1.038h1.946l.415 12.818a3.617 3.617 0 003.632 3.5zm-6.513-18.524a1.041 1.041 0 011.038-1.038h3.944a1.041 1.041 0 011.038 1.038v1.168h-6.02zm-3.087 14.971l-.415-12.791h13.051l-.441 12.791a2.6 2.6 0 01-2.595 2.517h-7.006a2.586 2.586 0 01-2.594-2.517z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11807",
    d: "M1608.013 121.946a.52.52 0 00.519-.519v-7.762a.519.519 0 00-1.038 0v7.758a.52.52 0 00.519.523z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11808",
    d: "M1604.9 121.946a.52.52 0 00.519-.519v-7.762a.519.519 0 00-1.038 0v7.758a.52.52 0 00.519.523z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11809",
    d: "M1611.127 121.946a.52.52 0 00.519-.519v-7.762a.519.519 0 00-1.038 0v7.758a.52.52 0 00.519.523z"
  }))));
}

export default __webpack_public_path__ + "0cc4e1fd154325d28c945a9a0f453caa.svg";
export { SvgPbDelete as ReactComponent };